import { useParams } from "react-router-dom";
import { Breadcrumb } from "../shell/Shell.js";
import { EvidenceContent } from "./EvidenceContent.js";

/**
 * Evidence drilldown — built to the locked demo (evidence.html): the drill-to-proof trail behind a
 * work item. Wired to E7.3 GET /work-items/:id/evidence, which returns the linked source events
 * (changes / CI / deploys) each citing its source/method/confidence — no orphan number. Honest about
 * M0: until entity resolution (E4, M1) links evidence to work items, most items have none, so the
 * screen shows the demo's honest empty trail ("connect a source — N/A, not a fabricated zero")
 * rather than inventing rows. Raw `content` is already role-masked by the API for client roles.
 */

export function Evidence(): React.ReactNode {
  const { id = "" } = useParams();
  const crumb = (
    <Breadcrumb
      items={[
        { label: "Portfolio", to: "/portfolio" },
        { label: "Work item" },
        { label: "Evidence" },
      ]}
    />
  );
  return (
    <>
      {crumb}
      <div className="head">
        <h1>
          Evidence <span className="sub">drill-to-proof trail</span>
        </h1>
      </div>
      <EvidenceContent workItemId={id} />
    </>
  );
}
